import { getCurrentLead } from 'tokenGeneration/lead.util';
import { setAnalyticsParamsforDedicated, setAnalyticsParamsforDedicatedAuth } from '../../common/utils/app.utils';

export const faOnDedicatedHomePageLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: 'b2b|dedicated internet|home page|feasibility',
    prop39: data && data.segment,
    prop40: data && data.productType
  });
};

export const faOnBuyNowClick = () => {
  setAnalyticsParamsforDedicated({
    eVar9: `b2b|dedicated internet|home page|buy now`,
    eVar8: `b2b|dedicated internet|home page`
  });
};

export const faOnDedicatedCheckFeasibiliyLoad = () => {
  setAnalyticsParamsforDedicated({
    eVar0: 'b2b|dedicated internet|home page|feasibility'
  });
};

export const faOnDedicatedNextClick = (data) => {
  setAnalyticsParamsforDedicated({
    eVar9: `b2b|dedicated internet|home page|feasibility|next`,
    eVar8: `b2b|dedicated internet|home page|feasibility`,
    prop16: data && data.customerDetails && data.customerDetails.selectedCity,
    prop19: data && data.customerDetails && data.customerDetails.pincode,
    prop20: data && data.customerDetails && data.customerDetails.address,
    prop24: data && data.customerDetails && data.customerDetails.requestedBandwidth
  });
};

// export const faOnTalktoExpertClick = () => {
//     setAnalyticsParamsforDedicated({
//         eVar9: `b2b|airtel internet|home page|try now`,
//         eVar8: `b2b|airtel internet|home page`,
//       });
// }
export const faOnDedicatedCustomerDetailsLoad = () => {
  setAnalyticsParamsforDedicated({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details`
  });
};

export const faOnDedicatedProceedClick = (data) => {
  setAnalyticsParamsforDedicated({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|proceed`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details`,
    prop35: data && data.companyName,
    prop17: data && data.customerName,
    prop15: data && data.email,
    prop14: data && data.phoneNumber
  });
};

export const faOnDedicatedUnauthPlanPageLoad = (data) => {
  setAnalyticsParamsforDedicated({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan unauth`,
    prop29: data && data.feasibilityStatus
  });
};

export const faOnSendQuoteClick = (service, period, speed) => {
  setAnalyticsParamsforDedicated({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan unauth|send quote`,
    prop22: period,
    prop24: speed,
    prop30: service
  });
};

export const faOnDedicatedAuthPlanPageLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`,
    prop29: data && data.feasibilityStatus,
    prop43: data && data.leadId
  });
};

export const faOnDedicatedSelectPlanClick = () => {
  setAnalyticsParamsforDedicated({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|select`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`
  });
};

export const faOnDedicatedContractPeriodLoad = () => {
  setAnalyticsParamsforDedicated({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration`
  });
};

export const faOnDedicatedContractPeriodOKClick = (year) => {
  setAnalyticsParamsforDedicated({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration|ok`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration`,
    prop22: year
  });
};

export const faOnDedicatedNeedAssistanceClick = () => {
  setAnalyticsParamsforDedicated({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration|ok|need assistance`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration`
  });
};
export const faOnDedicatedConfirmClick = (data) => {
  setAnalyticsParamsforDedicated({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration|ok|confirm`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration`,
    prop18: data && data.price && data.price.amount,
    prop23: data && data.price && data.price.otc,
    prop22: data && data.planPeriod,
    prop24: data && data.speed,
    prop30: data && data.service
  });
};
export const faOnDedicatedUnauthThanksPageLoad = (id) => {
  setAnalyticsParamsforDedicated({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan unauth|thank you`,
    prop21: id
  });
};

export const faOnDedicatedAuthThanksPageLoad = (id) => {
  setAnalyticsParamsforDedicated({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|thank you`,
    prop21: id
  });
};

export const faOnDedicatedAuthThanksPageLoadViaSummary = (id) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary|submit|otp verify|thank you`,
    prop21: id
  });
};

export const faOnDedicatedAuthThanksPageLoadViaChosePlan = (id) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|select plan|save order|thank you`,
    prop21: id
  });
};

export const faOnDedicatedReferBusinessSubmit = (data) => {
  setAnalyticsParamsforDedicated({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|thank you|submit`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|thank you`,
    prop35: data && data.companyName,
    prop17: data && data.customerName,
    prop15: data && data.email,
    prop14: data && data.phoneNumber
  });
};

export const faOnDedicatedAuthCheckFeasibiliyPage = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    prop39: data && data.segment,
    prop40: data && data.productType
  });
};

export const faOnDedicatedKamChoosePlanPageLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|kam view|customer request`,
    prop18: data && data.price && data.price.amount,
    prop22: data && data.planPeriod,
    prop24: data && data.speed,
    prop30: data && data.service,
    prop38: data && data.ipAttribute
  });
};

export const faOnDedicatedPlanConfiguration = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|${data.type} conf`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`
  });
};

export const faOnDedicatedKamPlanConfiguration = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|kam view|customer request|${data.type} conf`,
    eVar8: `b2b|dedicated internet|kam view|customer request`
  });
};

export const faOnDedicatedPlanConfigurationModalLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|edit conf`
  });
};

export const faOnDedicatedKamPlanConfigurationModalLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|kam view|customer request|edit conf`
  });
};

export const faOnDedicatedPlanConfigurationModalSubmit = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|edit conf|save`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|edit conf`
  });
};

export const faOnDedicatedKamPlanConfigurationModalSubmit = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|kam view|customer request|edit conf|save`,
    eVar8: `b2b|dedicated internet|kam view|customer request|edit conf`
  });
};

export const faOnDedicatedCancelClick = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|cancel`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`
  });
};

export const faOnDedicatedCancelOrderPopupLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|cancel`
  });
};

export const faOnDedicatedCancelOrderPopupSubmit = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|cancel|submit`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|cancel`,
    eVar25: data.remarks
  });
};

export const faOnDedicatedChangeRouterClick = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|cancel|change router`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|cancel`
  });
};

export const faOnDedicatedChangeRouterPopupLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|change router`
  });
};

export const faOnDedicatedChangeRouterPopupSubmit = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|change router|save`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|change router`
  });
};

export const faOnDedicatedSaveOrderClick = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|select plan|save order`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`
  });
};

export const faOnDedicatedKamSaveOrderClick = (data = {}) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|kam view|customer request|${data.planType}|submit price`,
    eVar8: `b2b|dedicated internet|kam view|customer request`,
    prop39: data.rental,
    prop40: data.otc,
    prop41: data.planPeriod,
    prop42: data.planSubType
  });
};

export const faOnDedicatedKamApprovalOrder = (data = {}) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|kam view|customer request|submit price|Approval`,
    eVar8: `b2b|dedicated internet|kam view|customer request`
  });
};

export const faOnDedicatedNeedAssistance = () => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|select plan|need assistance`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`
  });
};

export const faOnDedicatedNeedAssistancePopupLoad = () => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|select plan|need assistance`
  });
};

export const faOnDedicatedNeedAssistancePopupSubmit = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|select plan|need assistance|submit`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|select plan|need assistance`,
    eVar25: data.remarks
  });
};

export const faOnDedicatedNeedAssistancePopupSuccess = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|select plan|need assistance|thank you`
  });
};

export const faOnDedicatedPlanProceedClick = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|proceed`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`,
    prop18: data && data.price && data.price.amount,
    prop22: data && data.planPeriod,
    prop23: data && data.price && data.price.otc,
    prop24: data && data.speed,
    prop30: data && data.service,
    prop38: data && data.ipAttribute
  });
};

export const faOnDedicatedBookingSummaryModalLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|proceed`
  });
};

export const faOnDedicatedBookingSummaryModalSubmit = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|proceed|yes`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|proceed`
  });
};

export const faOnDedicatedSummaryPageLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary`
  });
};

export const faOnDedicatedSummaryPageCancel = (order) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|${order?.serviceType}|buy|confirm installations|site readiness widget|edit with excel page|cancel`,
    prop0: `b2b|${order?.lead?.customer?.segment}|${order?.serviceType}`,
    prop15: order?.customerEmail || '', //email address
    prop17: `${order?.lead?.customer?.authorizedSignatory?.firstName || ''} ${order?.lead?.customer?.authorizedSignatory?.lastName || ''}`, //full name
    prop14: order?.lead?.customer?.authorizedSignatory?.phoneNumber || '', //phone number
    prop35: order?.companyAddress?.officeName || '',
    prop39: order?.lead?.customer?.segment || '',
    prop40: order?.serviceType || '',
    prop37: order?.orderType || '',
    // prop41=<type of site>
    // Prop43=<no. of sites>
    // prop21=<feasibility request id>
    // Prop23=<link id>
    prop9: order?.companyAddress?.pincode || '',
    prop36: order?.lead?.customer?.authorizedSignatory?.companyName || '',
    prop20: order?.companyAddress?.addressLine1 || '',
    // Prop26=<bandwidth>
    // Prop28=<site type>
    prop10: order?.orderId || '',
    // Prop29=<media type>
    // Prop22=<contract period>
    prop18: order?.lead?.planDetail?.totalPrice || '',
    prop1: order?.purchaseOrder?.poNumber || '',
    prop24: order?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
    prop25: order?.purchaseOrder?.purchaseOrderDate || '',
    prop2: order?.purchaseOrder?.poAmount || '',
    prop3: order?.billingType || '',
    prop4: order?.billingCycle || '',
    prop5: order?.lead?.customer?.panNumber || '', //<account number>
    prop16: order?.companyAddress?.city || '',
    // Prop7=<full name of site contact details>
    // Prop8=<mobile number of site contact details>
    // Prop9=<email address of site contact details>
    // Prop37=<customer need by date>
    prop38: order?.fiscalCode?.id || ''
    // Prop11=<full name of CPM>
    // Prop12=<mobile number of CPM>
    // Prop13=<email address of CPM>
  });
};

export const faOnDedicatedSummaryPageSubmit = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary|submit`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary`,
    prop18: data && data.price && data.price.amount,
    prop19: data && data.billingType,
    prop22: data && data.planPeriod,
    prop24: data && data.speed,
    prop30: data && data.service
  });
};

export const faOnDedicatedSummaryCancelOrderPopupLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary|cancel`
  });
};

export const faOnDedicatedSummaryCancelOrderPopupSubmit = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary|cancel|submit`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary|cancel`,
    eVar25: data.remarks
  });
};

export const faOnDedicatedAehThankyouPageLoad = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|cancel|thank you`
  });
};

export const faOnDedicatedAehThankyouPageLoadViaSummary = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary|cancel|thank you`
  });
};

export const faOnDedicatedEmailPopupLoad = (data, planDetail) => {
  const lead = getCurrentLead();
  setAnalyticsParamsforDedicatedAuth({
    eVar0: `b2b|${data?.serviceType}|home page|feasibility|contact details|choose plan|booking summary|submit|otp verify`,
    prop0: `b2b|${data?.lead?.customer?.segment}|${data?.serviceType}`,
    prop15: data?.customerEmail || '',
    prop17: `${data?.lead?.customer?.authorizedSignatory?.firstName || ''} ${data?.lead?.customer?.authorizedSignatory?.lastName || ''}`,
    prop14: data?.lead?.customer?.authorizedSignatory?.phoneNumber || '',
    prop35: data?.companyAddress?.officeName || '',
    prop39: data?.lead?.customer?.segment || '',
    prop40: data?.serviceType || '',
    prop37: data?.orderType || '',
    // prop41=<type of site>
    // Prop43=<no. of sites>
    prop21: data?.lead?.connectivityLineItems?.[0]?.feasibilityId || '',
    // Prop23=<link id>
    prop9: data?.companyAddress?.pincode || '',
    prop36: data?.companyAddress?.officeName || '',
    prop20: data?.companyAddress?.addressLine1 || '',
    prop26: planDetail?.speed || '',
    // Prop28=<site type>
    prop10: data?.orderId || '',
    prop29: data?.lead?.connectivityLineItems?.[0]?.selectedMedia[0]?.media || '',
    // Prop22=<contract period>
    prop18: data?.lead?.planDetail?.totalPrice || '',
    prop1: data?.purchaseOrder?.poNumber || '',
    prop24: data?.documents?.PURCHASE_ORDER?.PO_DOCUMENT || '',
    prop25: data?.purchaseOrder?.purchaseOrderDate || '',
    prop2: data?.purchaseOrder?.poAmount || '',
    prop3: data?.billingType || '',
    prop4: data?.billingCycle || '',
    prop5: data?.lead?.customer?.panNumber || '',
    prop16: data?.companyAddress?.city || '',
    prop7: data?.siteIncharge?.firstName || '',
    prop8: data?.siteIncharge?.phoneNumber || '',
    prop9: data?.siteIncharge?.email || '',
    prop37: data?.lead?.connectivityLineItems?.[0]?.customerNeedDate || '',
    prop38: data?.fiscalCode?.id || ''
    // Prop11=<full name of CPM>
    // Prop12=<mobile number of CPM>
    // Prop13=<email address of CPM>
    // Prop14=<yes/no>
  });
};

export const faOnDedicatedEmailPopupSubmit = (data) => {
  setAnalyticsParamsforDedicatedAuth({
    eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary|submit|otp verify`,
    eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|booking summary|submit`
  });
};
